export const PATRIMONIO_ALERTA_MANUTENCAO_STATUS_ENUM = [
    {
        id: 'A_NOTIFICAR',
        descricao: "A Notificar",
        idDB: 0
    },
    {
        id: 'NOTIFICADO',
        descricao: "Notificado",
        idDB: 1
    },
];
